import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import NumberFormat from 'react-number-format';

import RenderIf from '../../../shared/render-if/components/render-if';
import Helpers from '../../../../common/helpers';
import constants from '../../../../common/constants';

import '../../payments/styles/payment-history-table.css';
import '../styles/campaigns-table.css';
import campaignsConstants from '../constants/campaigns-constants';
import registerConstants from '../../register/constants/register-constants';

class CampaignsTable extends Component {
  generateSiteUrl(link, profile, sites) {
    const site = _.find(sites, { page_code: link.link_url });
    const reason = site && campaignsConstants.special_campaigns.indexOf(site.page_name) !== -1 ? site.page_code : profile && profile.user_name;
    const url = site
      ? Helpers.formUrl(site, {
          reason,
          refcode: link.partner_code,
          code: link.partner_code,
        })
      : '';

    if (url) {
      window.open(url, '_blank');
    }
  }

  openCreateCampaignModal(link) {
    if (link.reference_type !== campaignsConstants.link_types.partner) {
      return;
    }

    const { toggleCreateCampaignModal } = this.props;

    toggleCreateCampaignModal(true, link);
  }

  renderTableHead(items) {
    const { t } = this.context;

    if (items && items.length > 0) {
      return items.map((item, index) => {
        return <th key={index}>{t(item.label)}</th>;
      });
    } else return null;
  }

  renderTableBody(items, profile, sites) {
    const { t } = this.context;
    const browser = Helpers.detectBrowser();
    const userType = profile && profile.user_type;

    if (items && items.length) {
      return items.map((item, index) => {
        return (
          <tr key={index} className="payment-history-table-container__table__body__row">
            <td>{item.reference_type === campaignsConstants.link_types.installation ? t('CAMPAIGNS.MOBILE_TRAFFIC') : item.link_name}</td>
            <td>{item.partner_code}</td>
            <RenderIf if={userType !== registerConstants.user_types.ifs_type}>
              <td>{item.installs_count || 0}</td>
            </RenderIf>
            <RenderIf if={userType !== registerConstants.user_types.ifs_type}>
              <td>{item.demo_referrals_count || 0}</td>
            </RenderIf>
            <RenderIf if={userType !== registerConstants.user_types.ifs_type}>
              <td>{item.live_referrals_count || 0}</td>
            </RenderIf>
            <td>
              <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.deposits_amount || 0).toFixed(2)} displayType={'text'} />
            </td>
            <td>
              <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.withdrawals_amount || 0).toFixed(2)} displayType={'text'} />
            </td>
            <td>
              <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.net_deposits || 0).toFixed(2)} displayType={'text'} />
            </td>
            <td>{item.trades_generated || 0}</td>
            <td>{item.valid_trades_generated || 0}</td>
            <td>
              <NumberFormat thousandSeparator={true} value={item.lots || 0} decimalScale={2} displayType={'text'} />
            </td>
            <td>
              <NumberFormat thousandSeparator={true} value={item.valid_lots || 0} decimalScale={2} displayType={'text'} />
            </td>
            <td>
              <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.commission_earned || 0).toFixed(2)} displayType={'text'} />
            </td>
            {userType !== registerConstants.user_types.ib &&
              userType !== registerConstants.user_types.ifs_type && [
                <td key={1}>
                  <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.commission_earned_trading || 0).toFixed(2)} displayType={'text'} />
                </td>,
                <td key={2}>
                  <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.commission_earned_achievement || 0).toFixed(2)} displayType={'text'} />
                </td>,
                <td key={3}>
                  <NumberFormat thousandSeparator={true} prefix={'$'} value={parseFloat(item.commission_pending || 0).toFixed(2)} displayType={'text'} />
                </td>,
              ]}
            <td onClick={() => this.generateSiteUrl(item, profile, sites)} className={`${browser !== constants.browsers.safari ? 'display-inline' : ''}`}>
              <div className="transparent-btn">{t('CAMPAIGNS.SHOW_SITE_BTN')}</div>
            </td>
            <td onClick={() => this.openCreateCampaignModal(item)}>
              <div className={`transparent-btn ${item.reference_type !== campaignsConstants.link_types.partner ? 'transparent-btn-disabled' : ''}`}>{t('COMMON.EDIT')}</div>
            </td>
          </tr>
        );
      });
    } else return null;
  }

  render() {
    const { campaigns, tableOptions, profile, sites } = this.props;
    const userType = profile && profile.user_type;
    const table = _.filter(tableOptions, option => {
      return !option.forbidden_user_types || option.forbidden_user_types.indexOf(userType) === -1;
    });

    return (
      <div className="payment-history-table-container table-responsive campaigns-table">
        <table className="payment-history-table-container__table">
          <thead className="payment-history-table-container__table__head">
            <tr className="payment-history-table-container__table__head__row">{this.renderTableHead(table)}</tr>
          </thead>
          <tbody className="payment-history-table-container__table__body">{this.renderTableBody(campaigns, profile, sites)}</tbody>
        </table>
      </div>
    );
  }
}

CampaignsTable.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default CampaignsTable;



// WEBPACK FOOTER //
// ./src/app/main/campaigns/components/campaigns-table.js